import styled from 'styled-components';

interface IInputAnimateProps {
  padding?: string;
  margin?: string;
  onlyWhite?: boolean | false;
}

export const Container = styled.div<IInputAnimateProps>`
  position: relative;
  line-height: 14px;
  display: inline-block;
  width: 100%;
  padding: ${props => props.padding ? props.padding : null};
  margin: ${props => props.margin ? props.margin : null};
  margin-bottom: 1rem;
`;

export const Input = styled.input<IInputAnimateProps>`
  width: 100%;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  border: 1px solid #40485f;
  color: #3e3f5e;
  background: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  transition: .3s ease-in-out;

  &:focus {
    border-color: #615dfa;
  }

  &:valid + label {
    font-size: .8rem;
    transform: translateY(-1.7rem);
  }

  &:invalid + label {
    transform: translateY(0);
  }

  &:focus + label {
    font-size: .8rem;
    transform:translateY(-1.7rem);
  }
`;

export const Label = styled.label<IInputAnimateProps>`
  color: #adafca;
  font-size: 14px;
  font-weight: 600;
  position: absolute;
  top: 20px;
  left: 1rem;
  padding: 0 5px;
  pointer-events: none;
  background: #fff;
  transition: .3s ease;
  transform: translateY(0);
`;

export const Erro = styled.p`
  color: #ff6961;
  text-align: left;
  padding: .25rem 0 .25rem .25rem;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;

  > span {
    margin-right: .5rem;
  }
`;
